import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {getEnv} from '../../../../../../common/env/env';
import {ApiStatusCodeVo} from '../../../../../../common/shared/api/cms/vo/enums/ApiStatusCodeVo.enum';
import {PagewebError} from '../../../../../../errors/PagewebError.class';
import {PagewebErrorType} from '../../../../../../errors/PagewebErrorType.enum';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {thunkSerializeError} from '../../../../../../errors/thunkSerializeError.function';
import {createShortVodPreviewViewerInfo} from '../../../../../../graphql/factory/ShortVodPreviewViewerInfo';
import {ShortVodPreviewViewerInfo} from '../../../../../../graphql/generated/types';
import {VIEWER_INFO_STATE_NAME} from '../constant/viewerConstant';

export const fetchShortVodViewerPreviewInfo = createAsyncThunk<
  ShortVodPreviewViewerInfo | undefined,
  {env?: string; previewKey: string},
  {serializedErrorType: SerializedPagewebError}
>(
  `${VIEWER_INFO_STATE_NAME}/fetchShortVodViewerPreviewInfo`,
  async ({env, previewKey}) => {
    let cmsApiOrigin = getEnv().cmsApiOrigin;
    if (env) {
      cmsApiOrigin = cmsApiOrigin.replace(
        /(https:\/\/)(.*)(-api-.*)/,
        `$1${env}$3`
      );
    }
    const url = `/product/external/video-preview/${previewKey}`;
    const response = await axios.get(url, {
      baseURL: cmsApiOrigin,
    });

    // 프리뷰 에러 발생시 처리
    if (response.data.status === ApiStatusCodeVo.ExpiredPreviewViewerToken) {
      throw new PagewebError({
        isSerializedPagewebError: true,
        type: PagewebErrorType.CmsApiStatusError,
        resultCode: response.data.status,
        message: response.data.detail,
      });
    }

    return createShortVodPreviewViewerInfo(response.data);
  },
  {
    serializeError: thunkSerializeError,
  }
);
